const o = "Kleurveld, huidige kleur is {color}", e = "Color field", l = "Colors palette", r = "Vooraf ingestelde kleuren", t = "Custom preset colors", s = "Add color", c = "Wis kleur", a = "Custom color, HEX format", n = "Voeg kleur toe aan overzicht van aangepaste kleuren", C = "Wis aangepast kleurveld", d = "Delete color with backspace", i = {
  currentColor: o,
  emptyColor: e,
  palette: l,
  presetColors: r,
  customColors: t,
  addColor: s,
  clearColor: c,
  colorField: a,
  colorFieldConfirm: n,
  colorFieldClear: C,
  deleteColorDescriber: d
};
export {
  s as addColor,
  c as clearColor,
  a as colorField,
  C as colorFieldClear,
  n as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  i as default,
  d as deleteColorDescriber,
  e as emptyColor,
  l as palette,
  r as presetColors
};
